import { z } from 'zod';

export const getUserDeviceAuthorizationsSchema = z.object({
  user_id: z.uuid('Valid user ID is required'),
  include_revoked: z.boolean().optional().default(false),
});

export type GetUserDeviceAuthorizationsPayload = z.infer<typeof getUserDeviceAuthorizationsSchema>;
